import React from "react";
import Resources from "../../../types/Resources";
import { Modal } from "react-bootstrap";
import ChecklistRadioOptions from "../../Common/ChecklistRadioOptions";
import ElectricDisconnectionChecklistFormState from "../../../types/forms/Permits/Conditions/ElectricDisconnectionChecklistFormState";
import { ElectricDisconnectionChecklist } from "../../../types/permits/conditions/ElectricDisconnectionChecklist";

type ElectricalDisconnectionChecklistModalProps = {
    checklistVersion: number;
    show: boolean;
    onHide: () => void;
    resources: Resources;
    onChange: (
        fn: (prevValue: ElectricDisconnectionChecklistFormState) => ElectricDisconnectionChecklistFormState
    ) => void;
    formState: ElectricDisconnectionChecklistFormState;
    canManageContent: boolean;
};

function ElectricalDisconnectionChecklistModal(props: ElectricalDisconnectionChecklistModalProps) {
    function changeHandler(key: keyof ElectricDisconnectionChecklistFormState, value: any) {
        props.onChange((prevValue) => {
            const updatedFormState: ElectricDisconnectionChecklistFormState = {
                ...prevValue,
                [key]: { ...prevValue[key], value }
            };

            return updatedFormState;
        });
    }

    return (
        <Modal show={props.show} onHide={props.onHide} size="xl">
            <Modal.Header closeButton>
                <h1 className="h5">{props.resources.get("MeasuresOnElectricalDisconnection")}</h1>
            </Modal.Header>
            <Modal.Body>
                <ul className="list-unstyled">
                    <li className="m-3 d-flex justify-content-between">
                        <div>{props.resources.get("WhoIsResponsibleElectrician")}</div>
                        <div className="d-flex align-items-center">
                            <label className="fw-bold" htmlFor="responsible-electrician-name">
                                {props.resources.get("Name")}:
                            </label>
                            <input
                                className={`form-control ms-1 me-1 ${!props.canManageContent ? "read-only-input" : ""}`}
                                type="text"
                                style={{ width: "140px" }}
                                value={props.formState.responsibleElectricianName.value ?? ""}
                                onChange={(e) => changeHandler("responsibleElectricianName", e.target.value)}
                                readOnly={!props.canManageContent}
                            />
                            <label className="fw-bold" htmlFor="responsible-electrician-phone-number">
                                {props.resources.get("Tel")}:
                            </label>
                            <input
                                id="responsible-electrician-phone-number"
                                className={`form-control ms-1 ${!props.canManageContent ? "read-only-input" : ""}`}
                                type="text"
                                style={{ width: "140px" }}
                                value={props.formState.responsibleElectricianPhoneNumber.value ?? ""}
                                onChange={(e) => changeHandler("responsibleElectricianPhoneNumber", e.target.value)}
                                readOnly={!props.canManageContent}
                            />
                        </div>
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="IsEquipmentConnectedToEarthFaultBreaker"
                            labelText={props.resources.get("IsEquipmentConnectedToEarthFaultBreaker")}
                            onChange={(updatedValue) =>
                                changeHandler("equipmentIsConnectedToEarthFaultBreaker", updatedValue)
                            }
                            resources={props.resources}
                            value={props.formState.equipmentIsConnectedToEarthFaultBreaker.value}
                            readOnly={!props.canManageContent}
                        />
                    </li>
                    {props.checklistVersion === 0 ? <li className="m-3">
                        <ChecklistRadioOptions
                            id="ElectricConnectionsAreAboveGround"
                            labelText={props.resources.get("AreElectricConnectionsAboveGround")}
                            onChange={(updatedValue) =>
                                changeHandler("electricConnectionsAreAboveGround", updatedValue)
                            }
                            resources={props.resources}
                            value={props.formState.electricConnectionsAreAboveGround.value}
                            readOnly={!props.canManageContent}
                        />
                    </li> : null}
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="PowerIsCutAndFusesRemoved"
                            labelText={props.resources.get("IsPowerCutAndFusesRemoved")}
                            onChange={(updatedValue) => changeHandler("powerIsCutAndFusesRemoved", updatedValue)}
                            resources={props.resources}
                            value={props.formState.powerIsCutAndFusesRemoved.value}
                            readOnly={!props.canManageContent}
                        />
                    </li>
                    {props.checklistVersion === 0 ? <li className="m-3">
                        <ChecklistRadioOptions
                            id="CablesAreWithoutRiskOfFalling"
                            labelText={props.resources.get("AreCablesWithoutRiskOfFalling")}
                            onChange={(updatedValue) => changeHandler("cablesAreWithoutRiskOfFalling", updatedValue)}
                            resources={props.resources}
                            value={props.formState.cablesAreWithoutRiskOfFalling.value}
                            readOnly={!props.canManageContent}
                        />
                    </li> : null}
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="SignIsAtElectricalBreaker"
                            labelText={props.resources.get("IsSignAtElectricBreaker")}
                            onChange={(updatedValue) => changeHandler("signIsAtElectricalBreaker", updatedValue)}
                            resources={props.resources}
                            value={props.formState.signIsAtElectricalBreaker.value}
                            readOnly={!props.canManageContent}
                        />
                    </li>
                </ul>
            </Modal.Body>
        </Modal>
    );
}

export default ElectricalDisconnectionChecklistModal;
